// extracted by mini-css-extract-plugin
export default {"modal":"VerifyPhoneMessagePopup_modal__93T5P"};